// extracted by mini-css-extract-plugin
export var footer = "_m9-5";
export var fulfillmentInput = "_m9-0";
export var shipDateInput = "_m9-1";
export var shipmentModal = "_m9-2";
export var shipmentModalContent = "_m9-3";
export var tableContainer = "_m9-4";